<template>
  <order-list :status="2"/>
</template>

<script>
import orderList from '@/views/order/components/orderList/orderList.vue'

export default {
  name: 'order-list-all',
  components: {
    orderList
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
